import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";
const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            await signInWithEmailAndPassword(auth, email, password);
            alert("Успешный вход!");
            navigate("/");  // переход на главную страницу
        } catch (err) {
            setError(err.message);
        }
    };


    return (
        <form onSubmit={handleLogin} className="flex flex-col max-w-sm mx-auto gap-4 p-4 bg-black bg-opacity-50 rounded">
            <h2 className="text-neonCyan text-2xl font-bold">Вход</h2>
            <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="p-2 rounded bg-gray-900 text-white"
                required
            />
            <input
                type="password"
                placeholder="Пароль"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="p-2 rounded bg-gray-900 text-white"
                required
            />
            <button type="submit" className="bg-neonPink text-black py-2 rounded font-bold hover:bg-pink-600 transition">
                Войти
            </button>
            {error && <p className="text-red-500">{error}</p>}
        </form>
    );
};

export default Login;
